import * as React from "react";

export const IconSignIn = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_1028_2242)">
            <path d="M9.16602 5.83333L7.99935 7L10.166 9.16667L1.66602 9.16667L1.66602 10.8333L10.166 10.8333L7.99935 13L9.16602 14.1667L13.3327 10L9.16602 5.83333ZM16.666 15.8333H9.99935V17.5H16.666C17.5827 17.5 18.3327 16.75 18.3327 15.8333L18.3327 4.16667C18.3327 3.25 17.5827 2.5 16.666 2.5L9.99935 2.5V4.16667L16.666 4.16667V15.8333Z" fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_1028_2242">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);